import { render } from "./AboutMe.vue?vue&type=template&id=6c86ffaa&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=6c86ffaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c86ffaa"]])

export default __exports__